import { Injectable } from '@angular/core';
import { Article, ArticleSearch, OccArticleSearchParams, ProductArticles } from '@article/const';
import { Store, select } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ArticleActions, ArticleSelectors, ArticlesActions, ArticlesSelectors, StateWithArticle } from '../store';

@Injectable({
  providedIn: 'root',
})
export class ArticlesSearchService {
  constructor(private store: Store<StateWithArticle>) {}

  loadList(params?: OccArticleSearchParams): void {
    this.store.dispatch(new ArticlesActions.ArticlesSearchLoad(params));
  }

  loadListByProductCode(productCode: string): void {
    this.store.dispatch(new ArticlesActions.ArticlesByProductCodeLoad(productCode));
  }

  getList(): Observable<ArticleSearch> {
    return this.store.pipe(select(ArticlesSelectors.getArticlesSearchValue), filter<ArticleSearch>(Boolean));
  }

  getProductArticles(productCode: string): Observable<ProductArticles> {
    return this.store.pipe(select(ArticlesSelectors.getProductArticlesValue(productCode)));
  }

  getArticleState(code: string): Observable<StateUtils.LoaderState<Article>> {
    return this.store.pipe(select(ArticleSelectors.getArticle(code)));
  }

  getArticle(code: string): Observable<Article> {
    return this.store.pipe(select(ArticleSelectors.getArticleValue(code)));
  }

  loadArticle(code: string): void {
    this.store.dispatch(new ArticleActions.ArticleLoad(code));
  }

  resetArticle(code: string): void {
    this.store.dispatch(new ArticleActions.ArticleReset(code));
  }

  saveRating(articleCode: string, rate: number): void {
    this.store.dispatch(new ArticleActions.ArticleSaveRating(articleCode, rate));
  }
}
